;(function () {
  'use strict'

  angular
    .module('admin.default_bounty_shinies.service', [])
    .factory('DefaultBountyShiniesService', DefaultBountyShiniesService)

  /** @ngInject */
  function DefaultBountyShiniesService($http, $q, API) {
    function list() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/default_bounty_shinies')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listPublish(start, limit, sort) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/default_bounty_shinies/published?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function listUnpublish(start, limit, sort) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/default_bounty_shinies/unpublished?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function listArchived(start, limit, sort) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/default_bounty_shinies/expired?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/default_bounty_shinies/' + id).success(defered.resolve)

      return defered.promise
    }

    function create(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/default_bounty_shinies', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/default_bounty_shinies/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/default_bounty_shinies/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/default_bounty_shinies/' + id + '/publish')
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/default_bounty_shinies/' + id + '/unpublish')
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, '', 'error')
        })

      return defered.promise
    }

    return {
      list: list,
      listPublish: listPublish,
      listUnpublish: listUnpublish,
      listArchived: listArchived,
      get: get,
      create: create,
      update: update,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
    }
  }
})()
